import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../index';

const selectLessonState = (state: RootState) => state.lesson;

export const selectLessonsByCourseId = createSelector(
    [selectLessonState, (_state: RootState, courseId: number) => courseId],
    (lessonState, courseId) => lessonState.lessons[courseId] || []
); 